
import {
  createComponent,
  onBeforeMount,
  onBeforeUnmount,
} from "@vue/composition-api";
import TypeWell from "./components/TypeWell.vue";
import TypeWellProvider from "./components/TypeWellProvider.vue";
import Help from "./components/Help.vue";

export default createComponent({
  components: {
    TypeWell,
    TypeWellProvider,
    Help,
  },
  setup() {
    // 非リアクティブ
    const title = "ブラウザ版 タイプウェル国語R（旧版）";
    const description = "※このアプリは非公式です";

    function keyInput(event: KeyboardEvent) {
      const ignoreKeyList: string[] = [" ", "F1", "F2", "F3", "F4"];
      for (const ignoreKey of ignoreKeyList) {
        if (event.key === ignoreKey) {
          event.preventDefault(); // デフォルトアクションを止める
        }
      }
    }

    onBeforeMount(() => {
      window.addEventListener("keydown", keyInput, true);
    });
    onBeforeUnmount(() => {
      window.removeEventListener("keydown", keyInput, true);
    });

    return {
      title,
      description,
    };
  },
});
